import { render } from "./NavSide.vue?vue&type=template&id=545295b6&scoped=true"
import script from "./NavSide.vue?vue&type=script&lang=js"
export * from "./NavSide.vue?vue&type=script&lang=js"

import "./NavSide.vue?vue&type=style&index=0&id=545295b6&scoped=true&lang=css"
import "./NavSide.vue?vue&type=style&index=1&id=545295b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545295b6"]])

export default __exports__